import { EmergencyContact } from "@/types/landing";

import api from "../api";

// Map backend response to frontend EmergencyContact
function fromBackendPayload(contact: any): EmergencyContact {
  return {
    backgroundColor: contact.background,
    buttonColor: contact.button_style,
    category: contact.category,
    description: contact.description,
    icon: contact.icon,
    iconColor: contact.icon_color,
    id: contact.id,
    isActive: contact.hidden === 0, // adjust if your backend uses a different field
    order: contact.order ?? 0,
    phoneNumber: contact.phone_number,
    title: contact.title,
  };
}

// Map frontend EmergencyContact to backend payload
function toBackendPayload(contact: EmergencyContact) {
  return {
    background: contact.backgroundColor,
    button_style: contact.buttonColor,
    category: contact.category,
    description: contact.description,
    icon: contact.icon,
    icon_color: contact.iconColor,
    phone_number: contact.phoneNumber,
    title: contact.title,
  };
}

export const EmergencyContactsService = {
  create: async (contact: EmergencyContact): Promise<EmergencyContact> => {
    const res = await api.post(
      "/emergency-contacts",
      toBackendPayload(contact),
    );
    return fromBackendPayload(res.data.contact);
  },

  delete: async (id: number | string): Promise<void> => {
    await api.delete(`/emergency-contacts/${id}`);
  },

  getAll: async (): Promise<EmergencyContact[]> => {
    const res = await api.get("/emergency-contacts");
    return (res.data.contacts || []).map(fromBackendPayload);
  },

  getById: async (id: number | string): Promise<EmergencyContact> => {
    const res = await api.get(`/emergency-contacts/${id}`);
    return fromBackendPayload(res.data.contact);
  },

  hide: async (id: number | string): Promise<void> => {
    await api.post(`/emergency-contacts/${id}/hide`);
  },

  unhide: async (id: number | string): Promise<void> => {
    await api.post(`/emergency-contacts/${id}/unhide`);
  },

  update: async (
    id: number | string,
    contact: EmergencyContact,
  ): Promise<EmergencyContact> => {
    const res = await api.put(
      `/emergency-contacts/${Number(id)}`,
      toBackendPayload(contact),
    );
    return fromBackendPayload(res.data.contact);
  },
};
